import { Component, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
declare var $;
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  privacyFlag : boolean = false;
  termsFlag : boolean = false;
  constructor(private translate: TranslateService) { }
  translationList = [];
  screenWidth: number = 1366;
  ngOnInit() {
    this.screenWidth = screen.width || window.screen.width;
    this.translate.get(['FOOTER.COPY_TEXT', 'FOOTER.PRIVACY_POLICY', 'FOOTER.TERMS_OF_USE', 'FOOTER.PRIVACY_POLICY_TEXT','FOOTER.TERMS_OF_USE_TEXT']).subscribe(label =>{
      this.translationList = label;
    });
  }

  privacyPolicyOpen(){
    this.screenWidth = screen.width || window.screen.width;
    this.privacyFlag = true;
    $('#displayDataModal').modal('show');
  }

  termsOfUseOpen(){
    this.screenWidth = screen.width || window.screen.width;
    this.termsFlag = true;
    $('#displayDataModal').modal('show');
  }

  closeModal(){
    $('#displayDataModal').modal('hide');
    this.privacyFlag = false;
    this.termsFlag = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/Screens/footer/footer.component.ts